module.exports = __webpack_public_path__ + "img/9548fd1.webp";